import axios from 'axios';

export const addEmailToNewTeamMemberAsync = async (
  parentId: number,
  childPosition: number,
  email: string
) => {
  return await axios.post(`/user/team/user`, {
    parentId,
    childPosition,
    email
  });
};

export const addEmailAndVerificationCodeAsync = async (
  approvalDate: string,
  referrerId: number,
  email: string,
  result: any
) => {
  const {
    lot_number: lotNumber,
    captcha_output: captchaOutput,
    pass_token: passToken,
    gen_time: genTime
  } = result;

  return await axios.post(`/authorization/signup/email`, {
    approvalDate,
    referrerId,
    email,
    lotNumber,
    captchaOutput,
    passToken,
    genTime
  });
};
